import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { CatalogCharacteristicObject } from 'src/app/models/catalog/catalog-characteristic-object.model';

@Component({
  selector: 'app-catalog-tab-characteristics',
  templateUrl: './catalog-tab-characteristics.component.html',
  styleUrls: ['./catalog-tab-characteristics.component.scss']
})
export class CatalogTabCharacteristicsComponent implements OnInit {

  @Input() characteristics: Array<CatalogCharacteristicObject>;

  dataSource: MatTableDataSource<CatalogCharacteristicObject>;
  displayedColumns: string[] = ['namingId', 'name', 'out', 'type'];


  constructor() {
  }

  ngOnInit() {
    this.characteristics = new Array<CatalogCharacteristicObject>();
    this.dataSource = new MatTableDataSource<CatalogCharacteristicObject>(this.characteristics);
  }

  ngOnChanges(): void {
    this.dataSource = new MatTableDataSource<CatalogCharacteristicObject>(this.characteristics);

  }

}
